import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  PuzzlePieceIcon,
  CloudIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon
} from '@heroicons/react/24/outline';

const integrations = [
  {
    id: 'zahara',
    name: 'Zahara',
    description: 'Sync projects, suppliers, and export purchase orders',
    icon: CloudIcon,
    status: 'available',
    link: '/app/zahara'
  },
  {
    id: 'coming-soon',
    name: 'More Integrations',
    description: 'Additional integrations coming soon',
    icon: PuzzlePieceIcon,
    status: 'coming-soon',
    link: null
  }
];

export const Integrations: React.FC = () => {
  const navigate = useNavigate();

  const handleIntegrationClick = (integration: any) => {
    if (integration.link) {
      navigate(integration.link);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="md:flex md:items-center md:justify-between">
        <div className="flex-1 min-w-0">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
            Integrations
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Connect Planted with your favorite tools and services
          </p>
        </div>
      </div>

      {/* Integration Status Overview */}
      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Integration Status</h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {integrations.map((integration) => (
            <div 
              key={integration.id} 
              onClick={() => handleIntegrationClick(integration)}
              className={`relative rounded-lg border border-gray-200 bg-white  dark:bg-gray-800 px-6 py-5 shadow-sm flex items-center space-x-3 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-primary-500 ${
                integration.link ? 'hover:border-gray-300 cursor-pointer' : 'cursor-default'
              }`}
            >
              <div className="flex-shrink-0">
                <integration.icon className="h-8 w-8 text-gray-400" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <p className="text-sm font-medium text-gray-900 truncate">
                    {integration.name}
                  </p>
                  {integration.status === 'available' && (
                    <CheckCircleIcon className="h-5 w-5 text-green-400" />
                  )}
                  {integration.status === 'coming-soon' && (
                    <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" />
                  )}
                </div>
                <p className="text-sm text-gray-500 truncate">
                  {integration.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};
